import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CbtaAvatarComponent } from "./cbta-avatar/cbta-avatar.component";
import { CbtaDatepickerComponent } from "./cbta-datepicker/cbta-datepicker.component";
import { CbtaDatetimePickerComponent } from "./cbta-datetime-picker/cbta-datetime-picker.component";
import { CbtaModalComponent } from "./cbta-modal/cbta-modal.component";

import {
	OWL_DATE_TIME_FORMATS,
	OwlDateTimeIntl,
	OwlDateTimeModule,
	OwlNativeDateTimeModule,
} from "@danielmoncada/angular-datetime-picker";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TableModule } from "ngx-easy-table";
import { DefaultIntl, MY_MOMENT_DATE_TIME_FORMATS } from "../constants/angular-datetime-picker.const";
import { MaterialModule } from "../material.module";
import { CbtaAutocompleteComponent } from "./cbta-autocomplete/cbta-autocomplete.component";
import { CbtaCheckboxRatingComponent } from "./cbta-checkbox-rating/cbta-checkbox-rating.component";
import { CbtaDaterangeFilterComponent } from "./cbta-daterange-filter/cbta-daterange-filter.component";
import { CbtaErrorModalContentComponent } from "./cbta-error-modal-content/cbta-error-modal-content.component";
import { CbtaFormSummaryModalComponent } from "./cbta-form-summary-modal/cbta-form-summary-modal.component";
import { CbtaOtherCommentsModalComponent } from "./cbta-other-comments-modal/cbta-other-comments-modal.component";
import { CbtaRatingSummaryCommentsComponent } from "./cbta-rating-summary-comments/cbta-rating-summary-comments.component";
import { CbtaRatingsProgressChartComponent } from "./cbta-ratings-progress-chart/cbta-ratings-progress-chart.component";
import { CbtaSignaturePadComponent } from "./cbta-signature-pad/cbta-signature-pad.component";
import { CbtaSignoffModalComponent } from "./cbta-signoff-modal/cbta-signoff-modal.component";
import { CbtaSliderComponent } from "./cbta-slider/cbta-slider.component";
import { CbtaStudentsTableComponent } from "./cbta-students-table/cbta-students-table.component";
import { CbtaSummaryRadarChartComponent } from "./cbta-summary-radar-chart/cbta-summary-radar-chart.component";
import { CbtaSwitchRoleModalComponent } from "./cbta-switch-role-modal/cbta-switch-role-modal.component";
import { CbtaViewSummaryModalComponent } from "./cbta-view-summary-modal/cbta-view-summary-modal.component";
import { FormSummaryModalComponent } from "./form-summary-modal/form-summary-modal.component";
import { Ts1V3FormSummaryModalComponent } from "src/app/cbta-web/ratings/container-ratings-form/ts1-rating-form-v3/widgets/ts1-v3-form-summary-modal/ts1-v3-form-summary-modal.component";
import { CommentAiAssistToolbarComponent } from "./comment-ai-assist-toolbar/comment-ai-assist-toolbar.component";

@NgModule({
	declarations: [
		CbtaAvatarComponent,
		CbtaModalComponent,
		CbtaDatepickerComponent,
		CbtaDatetimePickerComponent,
		CbtaDaterangeFilterComponent,
		CbtaAutocompleteComponent,
		CbtaStudentsTableComponent,
		CbtaSliderComponent,
		CbtaSwitchRoleModalComponent,
		CbtaCheckboxRatingComponent,
		CbtaSignaturePadComponent,
		CbtaSignoffModalComponent,
		CbtaOtherCommentsModalComponent,
		CbtaErrorModalContentComponent,
		CbtaViewSummaryModalComponent,
		CbtaFormSummaryModalComponent,
		CbtaSummaryRadarChartComponent,
		CbtaRatingsProgressChartComponent,
		CbtaRatingSummaryCommentsComponent,
		FormSummaryModalComponent,
		Ts1V3FormSummaryModalComponent,
		CommentAiAssistToolbarComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		OwlDateTimeModule,
		OwlNativeDateTimeModule,
		TableModule,
	],
	exports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		CbtaAvatarComponent,
		CbtaModalComponent,
		CbtaDatepickerComponent,
		CbtaDatetimePickerComponent,
		CbtaDaterangeFilterComponent,
		CbtaAutocompleteComponent,
		CbtaStudentsTableComponent,
		CbtaSliderComponent,
		CbtaSwitchRoleModalComponent,
		CbtaCheckboxRatingComponent,
		CbtaSignaturePadComponent,
		CbtaErrorModalContentComponent,
		CbtaViewSummaryModalComponent,
		CbtaFormSummaryModalComponent,
		CbtaSummaryRadarChartComponent,
		CbtaRatingsProgressChartComponent,
		CbtaRatingSummaryCommentsComponent,
		CommentAiAssistToolbarComponent,
	],
	providers: [
		{ provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_DATE_TIME_FORMATS },
		{ provide: OwlDateTimeIntl, useClass: DefaultIntl },
	],
})
export class SharedComponentsModule {}
